import { createAsyncThunk } from "@reduxjs/toolkit";
import { compressImage } from "global/imageCompressor";
import { axiosAuthRequest } from "request/request";
import { toast } from "react-toastify";

export const getStaffList = createAsyncThunk(
  "admin/getStaffList",
  async (id = null, { rejectWithValue }) => {
    try {
      let url = `staff/v1/staff-position`;
      if (id) {
        url += `?position_id=${id}`;
      }
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStaffById = createAsyncThunk(
  "admin/getStaffById",
  async ({ id, setModal }, { rejectWithValue }) => {
    try {
      let url = `staff/v1/staff-info?id=${id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        setModal(true);
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getPositionsList = createAsyncThunk(
  "admin/getPositionsList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/position`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createPosition = createAsyncThunk(
  "admin/createPosition",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/position`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getPositionsList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updatePosition = createAsyncThunk(
  "admin/updatePosition",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/position?id=${body.id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getPositionsList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deletePosition = createAsyncThunk(
  "admin/deletePosition",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/position?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getPositionsList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEducationRankList = createAsyncThunk(
  "admin/getEducationRankList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/education-rank`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addEducationRank = createAsyncThunk(
  "admin/addEducationRank",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/education-rank`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getEducationRankList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateEducationRank = createAsyncThunk(
  "admin/updateEducationRank",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/education-rank?id=${body.id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getEducationRankList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEducationRank = createAsyncThunk(
  "admin/deleteEducationRank",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/education-rank?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getEducationRankList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCities = createAsyncThunk(
  "admin/getCities",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/country`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addCity = createAsyncThunk(
  "admin/addCity",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/country`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getCities());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCity = createAsyncThunk(
  "admin/deleteCity",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/country?country_id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getCities());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSpecialityList = createAsyncThunk(
  "admin/getSpecialityList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/speciality`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addSpeciality = createAsyncThunk(
  "admin/addSpeciality",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/speciality`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getSpecialityList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSpeciality = createAsyncThunk(
  "admin/updateSpeciality",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/specality?id=${body.id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getSpecialityList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSpeciality = createAsyncThunk(
  "admin/deleteSpeciality",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/specality?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getSpecialityList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEducationSpeciality = createAsyncThunk(
  "admin/getEducationSpeciality",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/education-speciality`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addEducationSpeciality = createAsyncThunk(
  "admin/addEducationSpeciality",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/education-speciality`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getEducationSpeciality());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEducationSpeciality = createAsyncThunk(
  "admin/deleteEducationSpeciality",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/education-speciality?edu_sped_id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getEducationSpeciality());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCabinetTypes = createAsyncThunk(
  "admin/getCabinetTypes",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/cabinet-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addCabinetType = createAsyncThunk(
  "admin/addCabinetType",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/cabinet-type`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getCabinetTypes());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCabinetType = createAsyncThunk(
  "admin/deleteCabinetType",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/cabinet-type?cabinet_type_id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getCabinetTypes());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCafedras = createAsyncThunk(
  "admin/getCafedras",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/cafedra`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addCafedra = createAsyncThunk(
  "admin/addCafedra",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/cafedra`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getCafedras());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCafedra = createAsyncThunk(
  "admin/deleteCafedra",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/cafedra?cafedra_id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getCafedras());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCabinetsList = createAsyncThunk(
  "admin/getCabinetsList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/cabinet`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createStaff = createAsyncThunk(
  "admin/createStaff",
  async ({ closeModal, ...payload }, { rejectWithValue, dispatch }) => {
    let url = `staff/v1/staff`;

    try {
      const { data } = await axiosAuthRequest.post(url, payload);

      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getStaffList(null));

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateStaff = createAsyncThunk(
  "admin/updateStaff",
  async (
    { closeModal, staffId, ...payload },
    { rejectWithValue, dispatch }
  ) => {
    let url = `staff/v1/staff?staff_id=${staffId}`;

    try {
      const { data } = await axiosAuthRequest.put(url, payload);

      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getStaffList(null));

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTransferStatuses = createAsyncThunk(
  "admin/getTransferStatuses",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/transfer-status`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const transferStaff = createAsyncThunk(
  "admin/transferStaff",
  async ({ closeModal, ...payload }, { rejectWithValue, dispatch }) => {
    let url = `staff/v1/staff-transfer-order`;

    try {
      const { data } = await axiosAuthRequest.post(url, payload);

      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getStaffList(null));

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStaffArchiveList = createAsyncThunk(
  "admin/getStaffArchiveList",
  async (status, { rejectWithValue }) => {
    try {
      let url = `staff/v1/archived-staff?transfer_status_id=${status}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const restoreStaff = createAsyncThunk(
  "admin/restoreStaff",
  async (
    { closeModal, statusForGet, ...payload },
    { rejectWithValue, dispatch }
  ) => {
    let url = `staff/v1/staff-reinstatement-order`;

    try {
      const { data } = await axiosAuthRequest.post(url, payload);

      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getStaffArchiveList(statusForGet));

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getLessonTypeList = createAsyncThunk(
  "admin/getLessonTypeList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/assignment-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addLessonType = createAsyncThunk(
  "admin/addLessonType",
  async ({ setModal, ...payload }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/assignment-type`;
      const { data } = await axiosAuthRequest.post(url, payload);
      if (!data?.hasOwnProperty("error")) {
        setModal();
        toast.success("Иҷро шуд!");
        dispatch(getLessonTypeList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateLessonType = createAsyncThunk(
  "admin/updateLessonType",
  async ({ id, setModal, ...payload }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/assignment-type?id=${id}`;
      const { data } = await axiosAuthRequest.put(url, payload);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        setModal();
        dispatch(getLessonTypeList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteLessonType = createAsyncThunk(
  "admin/deleteLessonType",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/assignment-type?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getLessonTypeList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSubjectsList = createAsyncThunk(
  "admin/getSubjectsList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/subject-assignment-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getNationalityList = createAsyncThunk(
  "admin/getNationalityList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/nationality`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addNationality = createAsyncThunk(
  "admin/addNationality",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/nationality`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getNationalityList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateNationality = createAsyncThunk(
  "admin/updateNationality",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/nationality?id=${body.id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getNationalityList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteNationality = createAsyncThunk(
  "admin/deleteNationality",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/nationality?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getNationalityList());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addSubject = createAsyncThunk(
  "admin/addSubject",
  async ({ setModal, ...payload }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/subject-assignment-type`;
      const { data } = await axiosAuthRequest.post(url, payload);
      if (!data?.hasOwnProperty("error")) {
        setModal();
        toast.success("Иҷро шуд!");
        dispatch(getSubjectsList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSubject = createAsyncThunk(
  "admin/updateSubject",
  async ({ setModal, ...payload }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/subject-assignment-type`;
      const { data } = await axiosAuthRequest.put(url, payload);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        setModal();
        dispatch(getSubjectsList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSubject = createAsyncThunk(
  "admin/deleteSubject",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/subject_assignment-type?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getSubjectsList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSubjectsOptions = createAsyncThunk(
  "admin/getSubjectsOptions",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/subject`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEducationYear = createAsyncThunk(
  "admin/getEducationYear",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/education-year`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createEducationYear = createAsyncThunk(
  "admin/createEducationYear",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/education-year`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getEducationYear());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEducationHolidays = createAsyncThunk(
  "admin/getEducationHolidays",
  async ({ id }, { rejectWithValue }) => {
    try {
      let url = `education/v1/holidays?education_year_id=${id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createEducationHolidays = createAsyncThunk(
  "admin/createEducationHolidays",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/holiday`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        dispatch(getEducationHolidays({ id: body.education_year_id }));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createSemester = createAsyncThunk(
  "admin/createSemester",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/semester-property`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(
          getSemestersList({
            yearId: body.education_year_id,
            studentTypeId: body?.student_type_id,
          })
        );
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSemester = createAsyncThunk(
  "admin/updateSemester",
  async ({ id, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/semester-property?id=${id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        dispatch(
          getSemestersList({
            yearId: body.education_year_id,
            studentTypeId: body?.student_type_id,
          })
        );
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSemestersList = createAsyncThunk(
  "admin/getSemestersList",
  async ({ yearId, studentTypeId }, { rejectWithValue }) => {
    try {
      let url = `education/v1/semester-property?education_year_id=${yearId}&student_type=${studentTypeId}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentTypeList = createAsyncThunk(
  "admin/getStudentTypeList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/student-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSemester = createAsyncThunk(
  "admin/getSemester",
  async (_, { rejectWithValue }) => {
    try {
      let url = `/college/v1/semester`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getShifts = createAsyncThunk(
  "admin/getShifts",
  async (
    { education_year_id, semester_property_id, student_type_id },
    { rejectWithValue }
  ) => {
    try {
      let url = `education/v1/shift?education_year_id=${education_year_id}&semester_property_id=${semester_property_id}&student_type_id=${student_type_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createShift = createAsyncThunk(
  "admin/createShift",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/shift`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(
          getShifts({
            education_year_id: body?.education_year_id,
            semester_property_id: body?.semester_property_id,
            student_type_id: body?.student_type_id,
          })
        );
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateShiftLessonTime = createAsyncThunk(
  "admin/updateShiftLessonTime",
  async ({ filter, body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/lesson-time`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getShifts(filter));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addShiftLessonTime = createAsyncThunk(
  "admin/addShiftLessonTime",
  async (
    { education_year_id, semester_property_id, student_type_id, ...body },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `education/v1/lesson-time`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(
          getShifts({
            education_year_id: education_year_id,
            semester_property_id: semester_property_id,
            student_type_id: student_type_id,
          })
        );
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCabinetList = createAsyncThunk(
  "admin/getCabinetList",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/cabinet`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCabinet = createAsyncThunk(
  "admin/deleteCabinet",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/cabinet?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getCabinetList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCabinetBlock = createAsyncThunk(
  "admin/createCabinetBlock",
  async ({ closeModal, ...commonData }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/block`;
      const { data } = await axiosAuthRequest.post(url, commonData);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getCabinetBlocks());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCabinetBlock = createAsyncThunk(
  "admin/deleteCabinetBlock",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/block?block_id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getCabinetBlocks());

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCabinetBlocks = createAsyncThunk(
  "admin/getCabinetBlocks",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/block`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSubjects = createAsyncThunk(
  "admin/getSubjects",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/subject`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addSubjectsName = createAsyncThunk(
  "admin/addSubjects",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/subject`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        dispatch(getSubjects());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSubjectName = createAsyncThunk(
  "admin/updateSubjectName",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/subject?id=${body.id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getSubjects());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSubjectName = createAsyncThunk(
  "admin/updateSubjectName",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/subject?id=${id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(getSubjects());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCabinetStaffs = createAsyncThunk(
  "admin/getCabinetStaffs",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/staffs`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCabinet = createAsyncThunk(
  "admin/createCabinet",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/cabinet`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getCabinetList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateCabinet = createAsyncThunk(
  "admin/updateCabinet",
  async ({ closeModal, id, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/cabinet?id=${id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getCabinetList());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSubjectEducation = createAsyncThunk(
  "admin/getSubjectEducation",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/subject_education`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTeachers = createAsyncThunk(
  "admin/getTeachers",
  async (_, { rejectWithValue }) => {
    try {
      let url = `staff/v1/staffs?is_teacher=true`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStaffs = createAsyncThunk(
  "admin/getStaffs",
  async (_, { rejectWithValue }) => {
    try {
      let url = `staff/v1/staffs`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createSubject = createAsyncThunk(
  "admin/createSubject",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/subject-education`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getSubjectEducation());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateEducationSubject = createAsyncThunk(
  "admin/updateEducationSubject",
  async ({ closeModal, id, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/subject-education`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getSubjectEducation());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroups = createAsyncThunk(
  "admin/getGroups",
  async ({ studentType, yearId }, { rejectWithValue }) => {
    try {
      let url = `education/v1/group`;

      if (studentType) {
        url += url?.includes("?")
          ? `&student_type_id=${studentType}`
          : `?student_type_id=${studentType}`;
      }

      if (yearId) {
        url += url?.includes("?")
          ? `&education_year_id=${yearId}`
          : `?education_year_id=${yearId}`;
      }

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCurators = createAsyncThunk(
  "admin/getCurators",
  async (_, { rejectWithValue }) => {
    try {
      let url = `staff/v1/staffs/curators`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getHeadCurses = createAsyncThunk(
  "admin/getHeadCurses",
  async (_, { rejectWithValue }) => {
    try {
      let url = `staff/v1/staffs/head-course`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupNumber = createAsyncThunk(
  "admin/getGroupNumber",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/group_number`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createGroup = createAsyncThunk(
  "admin/createGroup",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/group`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getGroups({ studentType: body?.student_type_id }));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateGroup = createAsyncThunk(
  "admin/updateGroup",
  async ({ closeModal, id, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/group?id=${id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getGroups({ studentType: body?.student_type_id }));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCurriculumExamType = createAsyncThunk(
  "admin/getCurriculumExamType",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/exam-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupCurriculum = createAsyncThunk(
  "admin/getGroupCurriculum",
  async ({ gropuId, closeModal }, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/curriculum?group_id=${gropuId}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        if (closeModal) {
          closeModal();

          dispatch(getCurriculumExamType());
        }

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createGroupCurriculum = createAsyncThunk(
  "admin/createGroupCurriculum",
  async (
    { items, student_type_id, closeModal },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `education/v1/curriculum`;
      const { data } = await axiosAuthRequest.post(url, items);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");

        dispatch(getGroups({ student_type_id: student_type_id }));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteGroupCurriculum = createAsyncThunk(
  "admin/deleteGroupCurriculum",
  async (curriculumId, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/curriculum?id=${curriculumId}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupStudents = createAsyncThunk(
  "admin/getGroupStudents",
  async (gropuId, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/group-student?group_id=${gropuId}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getParentTypes = createAsyncThunk(
  "admin/getParentTypes",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      let url = `college/v1/parent_type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createStudent = createAsyncThunk(
  "admin/createStudent",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `student/v1/create-student`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getGroupStudents(body?.group_id));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentById = createAsyncThunk(
  "admin/getStudentById",
  async ({ studentId, setModal }, { rejectWithValue, dispatch }) => {
    try {
      let url = `student/v1/get-student-by-id?student_id=${studentId}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        setModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateStudent = createAsyncThunk(
  "admin/updateStudent",
  async (
    { closeModal, group_id, user_id, ...body },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `student/v1/update-student?user_id=${user_id}`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(getGroupStudents(group_id));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupSchedule = createAsyncThunk(
  "admin/getGroupSchedule",
  async (
    { group_id, semester_id, start_date, end_date },
    { rejectWithValue }
  ) => {
    try {
      let url = `schedule/v1/group-schedule?group_id=${group_id}&semester_id=${semester_id}&start_date=${start_date}&end_date=${end_date}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupLessonTime = createAsyncThunk(
  "admin/getGroupLessonTime",
  async ({ group_id, semester_id }, { rejectWithValue, dispatch }) => {
    try {
      let url = `schedule/v1/group-lessontime?group_id=${group_id}&semester_id=${semester_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const createSchedule = createAsyncThunk(
  "admin/createSchedule",
  async (
    { closeModal, group_id, end_date, ...body },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `schedule/v1/schedule`;
      const { data } = await axiosAuthRequest.post(url, {
        ...body,
        start_date: body.date,
      });
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        toast.success("Иҷро шуд!");
        dispatch(
          getGroupSchedule({
            group_id,
            end_date,
            semester_id: body?.semester_id,
            start_date: body?.start_date,
          })
        );
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupSemesterDatas = createAsyncThunk(
  "admin/getGroupSemesterDatas",
  async (group_id, { rejectWithValue, dispatch }) => {
    try {
      let url = `schedule/v1/group-semester-data?group_id=${group_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSchedule = createAsyncThunk(
  "admin/deleteSchedule",
  async (
    { schedule_id, end_date, start_date_get, ...body },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `schedule/v1/delete-schedule?schedule_id=${schedule_id}`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        dispatch(
          getGroupSchedule({
            group_id: body?.group_id,
            end_date: end_date,
            semester_id: body?.semester_id,
            start_date: start_date_get,
          })
        );
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSemesters = createAsyncThunk(
  "admin/getSemesters",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/semester`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCollegeInfo = createAsyncThunk(
  "admin/getCollegeInfo",
  async (_, { rejectWithValue }) => {
    try {
      let url = `/college/v1/college-information`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeCollegeInfo = createAsyncThunk(
  "admin/changeCollegeInfo",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      let url = `/college/v1/college-information`;
      const { data } = await axiosAuthRequest.put(url, body);
      if (!data?.hasOwnProperty("error")) {
        toast.success("Иҷро шуд!");
        setTimeout(() => dispatch(getCollegeInfo()), 100);
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeCollegeImage = createAsyncThunk(
  "admin/changeCollegeImage",
  async (
    { college_id, college_type, photo },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const formData = new FormData();
      formData.append("college_type", college_type);
      formData.append("photo", await compressImage(photo));

      let url = `avatar_img/v1/college/avatar?college_id=${college_id}`;
      const { data } = await axiosAuthRequest.put(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (!data?.hasOwnProperty("error")) {
        dispatch(getCollegeInfo());
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeUserAvatar = createAsyncThunk(
  "admin/changeUserAvatar",
  async ({ user_id, user_type, photo }, { rejectWithValue, dispatch }) => {
    try {
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("user_type", user_type);
      formData.append("photo", await compressImage(photo));

      let url = `/avatar_img/v1/user/avatar`;
      const { data } = await axiosAuthRequest.put(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getArchiveStatus = createAsyncThunk(
  "admin/getArchiveStatus",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/archived-status`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const archiveStudent = createAsyncThunk(
  "admin/archiveStudent",
  async ({ closeModal, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `student/v1/archived-student`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        dispatch(getGroupStudents(body?.group_id));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getArchivedStudents = createAsyncThunk(
  "admin/getArchivedStudents",
  async ({ education_year_id, archive_id, group_id }, { rejectWithValue }) => {
    try {
      let url = `student/v1/archived-student?education_year_id=${education_year_id}`;

      if (archive_id) {
        url += `&archive_id=${archive_id}`;
      }
      if (group_id) {
        url += `&group_id=${group_id}`;
      }
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTransferGroups = createAsyncThunk(
  "admin/getTransferGroups",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/transition-group`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTransferGroupStudents = createAsyncThunk(
  "admin/getTransferGroupStudents",
  async (groupId, { rejectWithValue }) => {
    try {
      let url = `education/v1/transition-group-student?group_id=${groupId}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const transferGroupApi = createAsyncThunk(
  "admin/transferGroupApi",
  async ({ closeModal, ...body }, { rejectWithValue }) => {
    try {
      let url = `education/v1/transition`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      const detailStr = error?.response?.data?.detail || "";
      const fixedJsonStr = detailStr.replace(/'/g, '"');
      try {
        const detailObj = JSON.parse(fixedJsonStr);
        toast.error(detailObj.message);
      } catch {
        toast.error(detailStr); // fallback — просто выводим строку
      }
      return rejectWithValue(error);
    }
  }
);

export const deleteStudentFromGroup = createAsyncThunk(
  "admin/deleteStudentFromGroup",
  async ({ group_student_id, group_id }, { rejectWithValue, dispatch }) => {
    try {
      let url = `student/v1/delete-group-student?group_student_id=${group_student_id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        dispatch(getGroupStudents(group_id));
        return data;
      } else {
        return;
      }
    } catch (error) {
      const detailStr = error?.response?.data?.detail || "";
      const fixedJsonStr = detailStr.replace(/'/g, '"');
      try {
        const detailObj = JSON.parse(fixedJsonStr);
        toast.error(detailObj.message);
      } catch {
        toast.error(detailStr); // fallback — просто выводим строку
      }
      return rejectWithValue(error);
    }
  }
);

export const getArchivedGroups = createAsyncThunk(
  "admin/getArchivedGroups",
  async (education_year_id, { rejectWithValue }) => {
    try {
      let url = `education/v1/archived-group?education_year_id=${education_year_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentsControl = createAsyncThunk(
  "admin/getStudentsControl",
  async ({ group_id, date, student_id }, { rejectWithValue }) => {
    try {
      let url = `student/v1/student-control?group_id=${group_id}&date=${date}`;

      if (student_id) {
        url += `&student_id=${student_id}`;
      }
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getLanguages = createAsyncThunk(
  "admin/getLanguages",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/languages`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSocialStatuses = createAsyncThunk(
  "admin/getSocialStatuses",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/social-status`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTargetedTraining = createAsyncThunk(
  "admin/getTargetedTraining",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/targeted-training`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getPersonIdByHikId = createAsyncThunk(
  "admin/getPersonIdByHikId",
  async (hikId, { rejectWithValue }) => {
    try {
      let url = `facehub/v1/hik/person?hikvision_id=${hikId}`;
      const { data } = await axiosAuthRequest.post(url, {});
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStaffTypes = createAsyncThunk(
  "admin/getStaffTypes",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/staff-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
